import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';
import { VideosCategory } from './VideosCategory';
@Component({
  selector: 'app-videos-category',
  templateUrl: './videos-category.component.html',
  styleUrls: ['./videos-category.component.scss']
})
export class VideosCategoryComponent implements OnInit {
videosCategory: VideosCategory;
url ;
p: any = 1;
collection: any[]=[]; 
curent;
  constructor(private http: HttpClient , private route: ActivatedRoute , public sanitizer: DomSanitizer) {
    var url_string = location.href;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
   }
   changel(){
    this.changeReq();
    $('li.pagination-next span').html(' ')
    $('li.pagination-next a').html(' ')
    $('li.pagination-previous  span').html(' ')
    $('li.pagination-previous  a').html(' ')
  }
  ngOnInit() {
    this.changeReq();
    setTimeout(()=>{
      $('.loaderParent').hide();
      $('li.pagination-next span').html(' ')
      $('li.pagination-next a').html(' ')
      $('li.pagination-previous  span').html(' ')
      $('li.pagination-previous  a').html(' ')
    }, 500)
 
  }
  changeReq(){
    $(window).scrollTop(0);
    this.http.get<VideosCategory>('http://servers.itresources.am/p_n/public/api/video/category/'+ this.curent, {
      params:{
         page: this.p,
        
      }
  
    }).subscribe(data => {
      this.videosCategory = data;
      var k =Number(data.meta.total);
      this.collection=[];
       for(let i =0 ; i<= k; i++) {
         this.collection.push(i)
       }
     
    });
  };
}
